exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-unit-square .input-square{padding-right:5px}.search-unit-square .input-unit{padding-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/admin/admin-detail.scss
// module id = 476
// module chunks = 0